// This file is auto-generated by @hey-api/openapi-ts

import { bambiApi } from '../internal/api.ts';
import {
  type RoutesRouteBambiRouteCreateApiArg,
  type RoutesRouteBambiRouteCreateApiResponse,
  type RoutesRouteTemplateDataListApiArg,
  type RoutesRouteTemplateDataListApiResponse,
  type RoutesRouteTemplateDataRetrieveApiArg,
  type RoutesRouteTemplateDataRetrieveApiResponse,
  type RoutesRouteTemplatesListApiArg,
  type RoutesRouteTemplatesListApiResponse,
  type RoutesRouteTemplatesCreateApiArg,
  type RoutesRouteTemplatesCreateApiResponse,
  type RoutesRouteTemplatesDestroyApiArg,
  type RoutesRouteTemplatesDestroyApiResponse,
  type RoutesRouteTemplatesRetrieveApiArg,
  type RoutesRouteTemplatesRetrieveApiResponse,
  type RoutesRouteTemplatesPartialUpdateApiArg,
  type RoutesRouteTemplatesPartialUpdateApiResponse,
  type RoutesRouteTemplatesMultiloadListApiArg,
  type RoutesRouteTemplatesMultiloadListApiResponse,
  type RoutesRouteTemplatesMultiloadCreateApiArg,
  type RoutesRouteTemplatesMultiloadCreateApiResponse,
  type RoutesRouteTemplatesMultiloadDestroyApiArg,
  type RoutesRouteTemplatesMultiloadDestroyApiResponse,
  type RoutesRouteTemplatesMultiloadRetrieveApiArg,
  type RoutesRouteTemplatesMultiloadRetrieveApiResponse,
  type RoutesRouteTemplatesMultiloadPartialUpdateApiArg,
  type RoutesRouteTemplatesMultiloadPartialUpdateApiResponse,
  type RoutesRouteTemplatesTripTemplatesListApiArg,
  type RoutesRouteTemplatesTripTemplatesListApiResponse,
  type RoutesRouteTemplatesTripTemplatesCreateApiArg,
  type RoutesRouteTemplatesTripTemplatesCreateApiResponse,
  type RoutesRouteTemplatesTripTemplatesDestroyApiArg,
  type RoutesRouteTemplatesTripTemplatesDestroyApiResponse,
  type RoutesRouteTemplatesTripTemplatesRetrieveApiArg,
  type RoutesRouteTemplatesTripTemplatesRetrieveApiResponse,
  type RoutesRouteTemplatesTripTemplatesPartialUpdateApiArg,
  type RoutesRouteTemplatesTripTemplatesPartialUpdateApiResponse,
  type RoutesRoutesListApiArg,
  type RoutesRoutesListApiResponse,
  type RoutesRoutesRetrieveApiArg,
  type RoutesRoutesRetrieveApiResponse,
} from './operations.gen.ts';

export const addTagTypes = ['routes'] as const;

const injectedRoutesRtkApi = bambiApi
  .enhanceEndpoints({ addTagTypes })
  .injectEndpoints({
    endpoints: (build) => ({
      routesRouteBambiRouteCreate: build.mutation<
        RoutesRouteBambiRouteCreateApiResponse,
        RoutesRouteBambiRouteCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/routes/route-bambi-route/`,
          method: 'POST',
          body: queryArg.applyRoutesRequest,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['routes'],
      }),
      routesRouteTemplateDataList: build.query<
        RoutesRouteTemplateDataListApiResponse,
        RoutesRouteTemplateDataListApiArg
      >({
        query: (queryArg) => ({
          url: `/routes/route-template-data/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: {
            active_after: queryArg.activeAfter,
            active_before: queryArg.activeBefore,
            active_on: queryArg.activeOn,
            days_of_week: queryArg.daysOfWeek,
            default_driver__in: queryArg.defaultDriverIn,
            name: queryArg.name,
            page: queryArg.page,
            page_size: queryArg.pageSize,
          },
        }),
        providesTags: ['routes'],
      }),
      routesRouteTemplateDataRetrieve: build.query<
        RoutesRouteTemplateDataRetrieveApiResponse,
        RoutesRouteTemplateDataRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/routes/route-template-data/${queryArg.id}/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        providesTags: ['routes'],
      }),
      routesRouteTemplatesList: build.query<
        RoutesRouteTemplatesListApiResponse,
        RoutesRouteTemplatesListApiArg
      >({
        query: (queryArg) => ({
          url: `/routes/route-templates/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: {
            active_after: queryArg.activeAfter,
            active_before: queryArg.activeBefore,
            active_on: queryArg.activeOn,
            days_of_week: queryArg.daysOfWeek,
            default_driver__in: queryArg.defaultDriverIn,
            name: queryArg.name,
            page: queryArg.page,
            page_size: queryArg.pageSize,
          },
        }),
        providesTags: ['routes'],
      }),
      routesRouteTemplatesCreate: build.mutation<
        RoutesRouteTemplatesCreateApiResponse,
        RoutesRouteTemplatesCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/routes/route-templates/`,
          method: 'POST',
          body: queryArg.routeTemplateWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['routes'],
      }),
      routesRouteTemplatesDestroy: build.mutation<
        RoutesRouteTemplatesDestroyApiResponse,
        RoutesRouteTemplatesDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/routes/route-templates/${queryArg.id}/`,
          method: 'DELETE',
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['routes'],
      }),
      routesRouteTemplatesRetrieve: build.query<
        RoutesRouteTemplatesRetrieveApiResponse,
        RoutesRouteTemplatesRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/routes/route-templates/${queryArg.id}/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        providesTags: ['routes'],
      }),
      routesRouteTemplatesPartialUpdate: build.mutation<
        RoutesRouteTemplatesPartialUpdateApiResponse,
        RoutesRouteTemplatesPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/routes/route-templates/${queryArg.id}/`,
          method: 'PATCH',
          body: queryArg.patchedRouteTemplateWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['routes'],
      }),
      routesRouteTemplatesMultiloadList: build.query<
        RoutesRouteTemplatesMultiloadListApiResponse,
        RoutesRouteTemplatesMultiloadListApiArg
      >({
        query: (queryArg) => ({
          url: `/routes/route-templates/${queryArg.routeTemplateId}/multiload/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['routes'],
      }),
      routesRouteTemplatesMultiloadCreate: build.mutation<
        RoutesRouteTemplatesMultiloadCreateApiResponse,
        RoutesRouteTemplatesMultiloadCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/routes/route-templates/${queryArg.routeTemplateId}/multiload/`,
          method: 'POST',
          body: queryArg.routeMultiloadTemplateWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['routes'],
      }),
      routesRouteTemplatesMultiloadDestroy: build.mutation<
        RoutesRouteTemplatesMultiloadDestroyApiResponse,
        RoutesRouteTemplatesMultiloadDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/routes/route-templates/${queryArg.routeTemplateId}/multiload/${queryArg.id}/`,
          method: 'DELETE',
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['routes'],
      }),
      routesRouteTemplatesMultiloadRetrieve: build.query<
        RoutesRouteTemplatesMultiloadRetrieveApiResponse,
        RoutesRouteTemplatesMultiloadRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/routes/route-templates/${queryArg.routeTemplateId}/multiload/${queryArg.id}/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        providesTags: ['routes'],
      }),
      routesRouteTemplatesMultiloadPartialUpdate: build.mutation<
        RoutesRouteTemplatesMultiloadPartialUpdateApiResponse,
        RoutesRouteTemplatesMultiloadPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/routes/route-templates/${queryArg.routeTemplateId}/multiload/${queryArg.id}/`,
          method: 'PATCH',
          body: queryArg.patchedRouteMultiloadTemplateWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['routes'],
      }),
      routesRouteTemplatesTripTemplatesList: build.query<
        RoutesRouteTemplatesTripTemplatesListApiResponse,
        RoutesRouteTemplatesTripTemplatesListApiArg
      >({
        query: (queryArg) => ({
          url: `/routes/route-templates/${queryArg.routeTemplateId}/trip-templates/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['routes'],
      }),
      routesRouteTemplatesTripTemplatesCreate: build.mutation<
        RoutesRouteTemplatesTripTemplatesCreateApiResponse,
        RoutesRouteTemplatesTripTemplatesCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/routes/route-templates/${queryArg.routeTemplateId}/trip-templates/`,
          method: 'POST',
          body: queryArg.routeTripTemplateWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['routes'],
      }),
      routesRouteTemplatesTripTemplatesDestroy: build.mutation<
        RoutesRouteTemplatesTripTemplatesDestroyApiResponse,
        RoutesRouteTemplatesTripTemplatesDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/routes/route-templates/${queryArg.routeTemplateId}/trip-templates/${queryArg.id}/`,
          method: 'DELETE',
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['routes'],
      }),
      routesRouteTemplatesTripTemplatesRetrieve: build.query<
        RoutesRouteTemplatesTripTemplatesRetrieveApiResponse,
        RoutesRouteTemplatesTripTemplatesRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/routes/route-templates/${queryArg.routeTemplateId}/trip-templates/${queryArg.id}/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        providesTags: ['routes'],
      }),
      routesRouteTemplatesTripTemplatesPartialUpdate: build.mutation<
        RoutesRouteTemplatesTripTemplatesPartialUpdateApiResponse,
        RoutesRouteTemplatesTripTemplatesPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/routes/route-templates/${queryArg.routeTemplateId}/trip-templates/${queryArg.id}/`,
          method: 'PATCH',
          body: queryArg.patchedRouteTripTemplateWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['routes'],
      }),
      routesRoutesList: build.query<
        RoutesRoutesListApiResponse,
        RoutesRoutesListApiArg
      >({
        query: (queryArg) => ({
          url: `/routes/routes/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: {
            page: queryArg.page,
            page_size: queryArg.pageSize,
            range_end: queryArg.rangeEnd,
            range_start: queryArg.rangeStart,
          },
        }),
        providesTags: ['routes'],
      }),
      routesRoutesRetrieve: build.query<
        RoutesRoutesRetrieveApiResponse,
        RoutesRoutesRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/routes/routes/${queryArg.id}/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        providesTags: ['routes'],
      }),
    }),
    overrideExisting: false,
  });

export const {
  useRoutesRouteBambiRouteCreateMutation,
  useRoutesRouteTemplateDataListQuery,
  useLazyRoutesRouteTemplateDataListQuery,
  useRoutesRouteTemplateDataRetrieveQuery,
  useLazyRoutesRouteTemplateDataRetrieveQuery,
  useRoutesRouteTemplatesListQuery,
  useLazyRoutesRouteTemplatesListQuery,
  useRoutesRouteTemplatesCreateMutation,
  useRoutesRouteTemplatesDestroyMutation,
  useRoutesRouteTemplatesRetrieveQuery,
  useLazyRoutesRouteTemplatesRetrieveQuery,
  useRoutesRouteTemplatesPartialUpdateMutation,
  useRoutesRouteTemplatesMultiloadListQuery,
  useLazyRoutesRouteTemplatesMultiloadListQuery,
  useRoutesRouteTemplatesMultiloadCreateMutation,
  useRoutesRouteTemplatesMultiloadDestroyMutation,
  useRoutesRouteTemplatesMultiloadRetrieveQuery,
  useLazyRoutesRouteTemplatesMultiloadRetrieveQuery,
  useRoutesRouteTemplatesMultiloadPartialUpdateMutation,
  useRoutesRouteTemplatesTripTemplatesListQuery,
  useLazyRoutesRouteTemplatesTripTemplatesListQuery,
  useRoutesRouteTemplatesTripTemplatesCreateMutation,
  useRoutesRouteTemplatesTripTemplatesDestroyMutation,
  useRoutesRouteTemplatesTripTemplatesRetrieveQuery,
  useLazyRoutesRouteTemplatesTripTemplatesRetrieveQuery,
  useRoutesRouteTemplatesTripTemplatesPartialUpdateMutation,
  useRoutesRoutesListQuery,
  useLazyRoutesRoutesListQuery,
  useRoutesRoutesRetrieveQuery,
  useLazyRoutesRoutesRetrieveQuery,
} = injectedRoutesRtkApi;
